import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from '../engagement/components/HeroSection';
import WhatKolanutDoesSection from '../engagement/components/WhatKolanutDoesSection';
import BenefitsSection from '../engagement/components/BenefitsSection';
import SocialProofSection from '../engagement/components/SocialProofSection';
import CtaSection from '../engagement/components/CtaSection';
import IntegrationsLogoSection from '../engagement/components/IntegrationsLogoSection';
import { SIGNUP_URL } from './engagementSaasContent';
import {
  engagementSaasHero,
  whatKolanutDoesSaasFeatures,
  saasBenefits,
  saasTestimonials,
  saasIntegrations,
} from './engagementSaasContent';

const EngagementSaasHome = () => {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    if (window.location.hash) {
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', cleanUrl);
    }
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow pb-20 sm:pb-0">
        <HeroSection
          showAudienceToggleSpacer={false}
          eyebrow="For SaaS teams"
          headline={
            <>
              See who&apos;s slipping.
              <br className="hidden sm:block" />
              <span className="sm:ml-0"> Reach them before they leave.</span>
            </>
          }
          subhead="Connect your product. Kolanut shows which accounts are at risk, never activated, or gone quiet. Then it drafts outreach you approve."
          hero={engagementSaasHero}
        />
        <WhatKolanutDoesSection
          features={whatKolanutDoesSaasFeatures}
          title="What Kolanut does for your SaaS"
          description="Connect your product. See who's at risk. Approve the outreach that brings them back."
        />
        <BenefitsSection
          items={saasBenefits}
          eyebrow="What you get"
          title="Keep more of the accounts you already won"
        />
        <IntegrationsLogoSection items={saasIntegrations} />
        <SocialProofSection
          items={saasTestimonials}
          eyebrow="SaaS teams using Kolanut"
          title="Growth leaders who can finally see which accounts need them"
        />
        <CtaSection
          title="Ready to see which accounts need you?"
          description="Connect your product stack and start with a free trial. No credit card."
        />
      </main>
      <Footer />

      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-white/40 backdrop-blur-md border-t border-gray-200/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:hidden z-40">
        <a
          href={SIGNUP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full py-3.5 rounded-full bg-[#8ae690] text-black font-bold text-base shadow-lg hover:bg-[#7ad67f] active:scale-[0.98] transition-all duration-200"
        >
          Get Started
        </a>
      </div>

      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }
        body {
          overflow-x: hidden;
        }
      `}</style>
    </div>
  );
};

export default EngagementSaasHome;
